import React, { useEffect, useState } from 'react'
import { createCookie, readCookie } from '../../../Helpers/Cookies';

import Modal from '../../Common/Organism/Modal';
import ModalWizard from '../../../Pages/ModalWizard';
import IconWizard from '../../../Statics/Imgs/iconWizard';
import IconClose from '../../../Statics/Imgs/iconClose';


const ModalByCookie = () => {
    const [showModalSteps, setShowModalSteps] = useState(false);
    const [showTooltipSteps, setShowTooltipSteps] = useState(false);

    /**
   * FUN MODAL STEPS 
   * mostramos el modal de lo que se puede hacer en mi cuenta
   * generacion de cookie y estados de modal y tooltip
   */  
    const handleModalSteps = ()=>{
        let nameCookie = "ModalSeenV1";
        let modalCookie = readCookie(nameCookie);

        //No hay cookie muestro modal y grabo cookie
        if(!!!modalCookie){
        try{
            setShowModalSteps(true);
            createCookie(nameCookie, true, 360);
        }catch{
            console.log("error write cookie and show modal");
        }
        }

    }
    const handleCloseModal = ()=>{
        setShowModalSteps(false);
        setShowTooltipSteps(true);    
    }
    useEffect(() => {
        setTimeout(() => {
            handleModalSteps();
        }, 500);
    }, [showModalSteps])


    return (
        <>
            <div className="headerWizard">
                <button aria-label="Abrir wizzard." className="buttonWizard" onClick={ ()=> setShowModalSteps(true) }>
                <IconWizard/>
                </button>
                {           
                showTooltipSteps &&
                <div className="tooltipWizard">
                    <div className="contentWizard">
                    <p className="com-paragraph --fivexs --arial" >Volvé a reproducir el tutorial cuando quieras</p>
                    <button className="tooltipWizard__close" onClick={ ()=> setShowTooltipSteps(false)} >
                        <IconClose />
                    </button>
                    </div>
                </div>
                }
            </div>

            {showModalSteps &&  
            <Modal
                closeModal={handleCloseModal}
                classes="--none"
            >
                <ModalWizard close={handleCloseModal} />
            </Modal> 
            }
        </>
    )
}

export default ModalByCookie;
